import { generateIconComponent } from './icons.utils';

export const LikeIcon = generateIconComponent({
    name: 'LikeIcon',
    viewBox: '0 0 24 24',
    path: (
        <path d="M12 21.0001C12 21.0001 5.40002 16.0001 2.00002 12.0001C-0.299978 9.30008 2.14577e-05 4.90008 2.90002 2.60008C5.70002 0.400084 9.30002 1.00008 12 4.00008C14.7 1.00008 18.3 0.400084 21.1 2.60008C24 4.90008 24.3 9.30008 22 12.0001C18.6 16.0001 12 21.0001 12 21.0001Z" />
    ),
});
